/**
 * Auth-related mutations — user-preference patches + Slack pairing.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ThemeMode } from '@/lib/theme';

interface PreferencesPatch {
  theme_preference?: ThemeMode;
  slack_user_id?: string;
  slack_enabled?: number;
}

interface StatusOk {
  status: 'ok';
}

export function useUpdatePreferencesMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: PreferencesPatch) =>
      api.patch<StatusOk>('/v1/auth/me/preferences', patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'me'] }),
  });
}

/** Resolve + cache the current user's Slack member id from their e-mail. */
export function useResolveSlackMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ slack_user_id: string }>('/v1/auth/me/slack/resolve'),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'me'] }),
  });
}
